// Copyright (c) 2021 Deere & Company
export default Object.freeze({
    ADD_SUCCESS_ALERT_MESSAGE: 'ADD_SUCCESS_ALERT_MESSAGE',
    DISCARD_ALERT_MESSAGES: 'DISCARD_ALERT_MESSAGES',
    ADD_ERROR_ALERT_MESSAGE: 'ADD_ERROR_ALERT_MESSAGE',
    DECREASE_BUSY_COUNTER: 'DECREASE_BUSY_COUNTER',
    INCREASE_BUSY_COUNTER: 'INCREASE_BUSY_COUNTER',
    RESET_BUSY_COUNTER: 'RESET_BUSY_COUNTER',
    UPDATE_OKTA_STATE_IS_AUTHENTICATED: 'UPDATE_OKTA_STATE_IS_AUTHENTICATED',
    UPDATE_OKTA_STATE_USER_NAME: 'UPDATE_OKTA_STATE_USER_NAME',
    UPDATE_OKTA_STATE_USER_ID: 'UPDATE_OKTA_STATE_USER_ID',
    GET_ADMIN_DATA: 'GET_ADMIN_DATA',
    GET_DEALER_PIN_TRANSFER_DATA: 'GET_DEALER_PIN_TRANSFER_DATA',
    SET_FLAG_FOR_ADMIN: 'SET_FLAG_FOR_ADMIN',
    GET_NOTIFICATION_DATA: 'GET_NOTIFICATION_DATA',
    UPDATE_MODAL_VISIBILITY: 'UPDATE_MODAL_VISIBILITY',
    GET_USER_SETTINGS_DATA: 'GET_USER_SETTINGS_DATA',
    GET_USER_DEALER_MAPPED_DATA: 'GET_USER_DEALER_MAPPED_DATA',
    RESET_USER_DEALER_MAPPED_DATA: 'RESET_USER_DEALER_MAPPED_DATA',
    RESET_PIN_SEARCH_DATA: 'RESET_PIN_SEARCH_DATA',
    GET_PIN_SEARCH_DATA: 'GET_PIN_SEARCH_DATA',
    RESET_DEALER_SEARCH_RESULTS: 'RESET_DEALER_SEARCH_RESULTS',
    RESET_DEALER_SEARCH_PARAMS: 'RESET_DEALER_SEARCH_PARAMS',
    RESET_DUPLICATE_PIN_PLATE: 'RESET_DUPLICATE_PIN_PLATE',
    UPDATE_DEALER_SEARCH_RESULTS_SUCCESS: 'UPDATE_DEALER_SEARCH_RESULTS_SUCCESS',
    UPDATE_DIVISION_SUCCESS: 'UPDATE_DIVISION_SUCCESS',
    UPDATE_DEALER_SEARCH_DIVISION_PARAMS: 'UPDATE_DEALER_SEARCH_DIVISION_PARAMS',
    UPDATE_DEALER_SEARCH_PARAMS: 'UPDATE_DEALER_SEARCH_PARAMS',
    UPDATE_ACCOUNT_LOOKUP: 'UPDATE_ACCOUNT_LOOKUP',
    UPDATE_NEW_TRANSFER_AMOUNT_OF_USE_MODAL_VISIBILITY: 'UPDATE_NEW_TRANSFER_AMOUNT_OF_USE_MODAL_VISIBILITY',
    CREATE_NEW_TRANSFER_SUCCESS: 'CREATE_NEW_TRANSFER_SUCCESS',
    RESET_NEW_TRANSFER: 'RESET_NEW_TRANSFER',
    UPDATE_DEALER_SEARCH_MODAL_VISIBILITY: 'UPDATE_DEALER_SEARCH_MODAL_VISIBILITY',
    UPDATE_TCSM_DUPLICATE_PIN_PLATE: 'UPDATE_TCSM_DUPLICATE_PIN_PLATE',
    UPDATE_NEW_TRANSFER_STATUS_CHANGE_MODAL: 'UPDATE_NEW_TRANSFER_STATUS_CHANGE_MODAL',
    UPDATE_NEW_TRANSFER_PRODUCT_SUCCESS: 'UPDATE_NEW_TRANSFER_PRODUCT_SUCCESS',
    UPDATE_DETAILS_ERROR: 'UPDATE_DETAILS_ERROR',
    RESET_PRODUCT_CUSTOMER_DETAILS: 'RESET_PRODUCT_CUSTOMER_DETAILS',
    UPDATE_NEW_TRANSFER_NEW_DEALER: 'UPDATE_NEW_TRANSFER_NEW_DEALER',
    UPDATE_NEW_TRANSFER_SUCCESS: 'UPDATE_NEW_TRANSFER_SUCCESS',
    UPDATE_REASON_FOR_CHANGE: 'UPDATE_REASON_FOR_CHANGE',
    CREATE_ALERT_MESSAGE: 'CREATE_ALERT_MESSAGE',
    DELETE_ALERT_MESSAGE: 'DELETE_ALERT_MESSAGE',
    DISMISS_ALERT_MESSAGES: 'DISMISS_ALERT_MESSAGES',
    RESET_CKC_CUSTOMER_FAILURE: 'RESET_CKC_CUSTOMER_FAILURE',
    RESET_ACCOUNT_LOOKUP: 'RESET_ACCOUNT_LOOKUP',
    UPDATE_LATEST_PER_UNIT_MEASUREMENTS: 'UPDATE_LATEST_PER_UNIT_MEASUREMENTS',
    RESET_LATEST_PER_UNIT_MEASUREMENTS: 'RESET_LATEST_PER_UNIT_MEASUREMENTS',
    RESET_DEALER_PIN_TRANSFER_DATA: 'RESET_DEALER_PIN_TRANSFER_DATA',
    UPDATE_TRANSFER_COMMENT_SUCCESS: 'UPDATE_TRANSFER_COMMENT_SUCCESS',
    GET_PIN_PLATE_REQUEST_DATA: 'GET_PIN_PLATE_REQUEST_DATA',
    RESET_PIN_PLATE_REQUEST_DATA: 'RESET_PIN_PLATE_REQUEST_DATA',
});
